export default __webpack_public_path__ + "locales/en/FilesSettings.json?hash=023aea88b656d802dcb9d26b1fbc61ee";